export default __webpack_public_path__ + "static/media/bnbSvg.d559b379.svg";